function initMainCollectionAnimations() {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  // Clear any existing triggers (important if re-init)
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());

  const mainCollection = document.querySelector('.s-main-collection');
  if (!mainCollection) return;

  const title = mainCollection.querySelector('.s-main-collection__title');
  const description = mainCollection.querySelector('.s-main-collection__description');
  const productCards = mainCollection.querySelectorAll('.s-main-collection__list .c-product-card');
  const promoBlocks = mainCollection.querySelectorAll('.s-main-collection__promotion');

  // Animate Title
  if (title) {
    gsap.fromTo(title,
      { y: 30, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: title,
          start: 'top 80%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  // Animate Description
  if (description) {
    gsap.fromTo(description,
      { y: 30, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        delay: 0.15,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: description,
          start: 'top 80%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  // Animate Product Cards
  productCards.forEach((card) => {
    gsap.fromTo(card,
      { opacity: 0, y: 60 },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        overwrite: 'auto',
        clearProps: 'transform',
        scrollTrigger: {
          trigger: card,
          start: 'top 80%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  });

  // Animate Promo Blocks
  promoBlocks.forEach((promo) => {
    gsap.fromTo(promo,
      { opacity: 0, y: 60 },
      {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: promo,
          start: 'top 80%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  });

  // Refresh scroll layout
  ScrollTrigger.refresh();
}

// Initial run when DOM is ready
document.addEventListener('DOMContentLoaded', initMainCollectionAnimations);

// Watch for product list changes (Load More, Filters, etc.)
const collectionList = document.querySelector('.s-main-collection__list');
if (collectionList) {
  const observer = new MutationObserver(() => {
    requestAnimationFrame(() => initMainCollectionAnimations());
  });

  observer.observe(collectionList, {
    childList: true,
    subtree: true,
  });
}
